export default "__VITE_ASSET__BDCpWpko__"